import { isUndefined } from 'lodash';
import axios, { postRequest } from 'src/utils/axios';
import logger from 'src/utils/logger';
import parse from 'src/utils/parse';


// Generic helper: preserves backend message if available, else falls back to generic
const handleApiError = (error: any): Error => {
  const message = error?.response?.data?.message;
  if (message) {
    const err = new Error(message);
    (err as any).response = error.response;
    return err;
  }
  return new Error('internal Server Error');
};

class OrganizationApi {
  async getAll(
    page: number,
    pageSize: number,
    isActivated: boolean
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES
          }/organization?page=${page}&pageSize=${pageSize}${isActivated !== null ? `&isActive=${isActivated}` : ''
          }`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            const res = response.data;
            resolve(res);
          } else {
            // reject(new Error(i18next.t("invalid_server_response")));
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));

        });
    });
  }

  async bulkDeactivate(checkedIds: Array<number>): Promise<any> {
    return new Promise((resolve, reject) => {
      const payload: any = {
        list: checkedIds,
      };
      axios
        .patch(
          `${process.env.REACT_APP_ORGANIZATION_URL}/bulk-deactivate`,
          payload
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            // const res = response.data;
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));

        });
    });
  }

  async create(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        // reject(new Error(error));
        reject(error);
      };
      const data = {
        url: `${process.env.REACT_APP_CASES}/organization`,
        payload,
        successFunction,
        errorFunction,
      };
      postRequest(data);
    });
  }

  async createSubOrganization(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_CASES}/organization`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));
        });
    });
  }

  async createSubOrganizationFromUserModal(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_CASES}/organization/createSubOrganization`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));
        });
    });
  }

  async createClient(payload: {
    organizationName: string;
    organizationTypeId: string;
    companyRegistration?: string;
    telephone?: string;
    email?: string;
    website?: string;
    domainName?: string;
    street?: string;
    city?: string;
    country?: string;
    postalCode?: string;
    timeZone?: string;
    firstName: string;
    lastName: string;
    designation?: string;
    language?: string;
    contactTelephone?: string;
    contactEmail: string;
  }): Promise<{
    organizationId: string;
    clientContactId: string;
    status: string;
  }> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_CASES}/organization/createClient`, payload)
        .then((response) => {
          response = parse(response);
          const data = response?.data?.data ?? response?.data;
          if (!isUndefined(data?.organizationId) || !isUndefined(data)) {
            resolve(data);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));
        });
    });
  }

  async getById(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/organization/${id}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            // const res = response.data;
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));
        });
    });
  }

  async getAllProjects(
    page: number,
    pageSize: number,
    search?: string,
    columns?: string,
    sortVal?: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const payload = {
        page,
        pageSize,
        search,
        column: columns,
        sort: sortVal === 'asc' ? '1' : '-1',
        isVisible: true,
      };
      if (search === '') {
        delete payload.search;
      }
      if (columns === undefined || columns === '') {
        delete payload.column;
        delete payload.sort;
      }

      if (sortVal === '') {
        delete payload.sort;
      }
      axios
        .get(`${process.env.REACT_APP_CASES}/project`, { params: payload })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getAllProjectbyOrg(
    id: String,
    page: number,
    pageSize: number,
    search: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/project?organizationId=${id}&page=${page}&pageSize=${pageSize}&name=${search}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(handleApiError(error));

        });
    });
  }

  async deleteProjByOrg(id: String): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${process.env.REACT_APP_CASES}/project/projectId?projectId=${id}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error));

        });
    });
  }

  async deleteProjById(id: String): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${process.env.REACT_APP_CASES}/project/${id}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error));

        });
    });
  }

  async updateById(id: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .put(`${process.env.REACT_APP_CASES}/organization/${id}`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));

        });
    });
  }

  async updateStatusById(id: number) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${process.env.REACT_APP_CASES}/organization/${id}/isActive`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            // const res = response.data;
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));

        });
    });
  }

  async deleteOrg(id: String) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${process.env.REACT_APP_ORGANIZATION_URL}/${id}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            // const res = response.data;
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));

        });
    });
  }

  async createProject(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_CASES}/project`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getOrganizationType(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/auto-complete/organization/types`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error));

        });
    });
  }

  async getOrganizationTypes(
    paramsData: Record<string, any> = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const defaultParams = {
        isActive: true,
        search: '',
        page: 0,
        pageSize: 25,
      };

      axios
        .get(`${process.env.REACT_APP_CASES}/organization/type`, {
          params: { ...defaultParams, ...paramsData },
        })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));

        });
    });
  }

  async getContactsByOrg(orgId: string, isActivated: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/contact?organizationId=${orgId}&${isActivated !== null && `isActive=${isActivated}`
          }`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));

        });
    });
  }

  async getOrgSummary(orgId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/organization/${orgId}/overview`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getByParentId(
    parentId: string,
    page: number = 0,
    pageSize: number = 25
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/organization?page=${page}&pageSize=${pageSize}&parentId=${parentId}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(handleApiError(error));
        });
    });
  }
}

export const organizationApi = new OrganizationApi();
